import { type VariantProps, cva } from 'class-variance-authority';

export { default as GraphicsTriangle } from './Triangle.vue';

export const triangleVariants = cva(
  'size-full overflow-visible fill-transparent stroke-[1px] [stroke-dasharray:100] [stroke-dashoffset:100]',
  {
    variants: {
      stroke: {
        black: 'stroke-black text-black',
        white: 'stroke-white text-white',
        beige: 'stroke-beige text-beige'
      }
    },
    defaultVariants: {
      stroke: 'black'
    }
  }
);

export type TriangleVariants = VariantProps<typeof triangleVariants>;
